import routes from "../../routes";
import { toLoginUrl } from "../../routing-utils";

export const savePriceItem = (
	{ planCode, planID, prices },
	context,
	{ storageService, authService },
) => {
	storageService.priceItem.write({
		planCode,
		planID,
		seats: prices[0].subscriptionSize,
		price: prices[0].price,
		purchaseType: "subscription",
	});

	const path = !authService.isAuthorized()
		? toLoginUrl({ returnUrl: routes.purchase.billing })
		: routes.purchase.billing;

	return path;
};
